import type { ErrorCode } from './protocol.ts'
import type { Theme } from './theme.ts'

export const ACTION_LIST = 'payment_method.list'
export const ACTION_CARD_CREATE = 'payment_method.card.create'
export const ACTION_SELECT = 'payment_method.select'

export interface PaymentMethodSummary {
  paymentMethodId: number
  paymentType: 'card' | 'ach'
  brand: string | null
  last4: string
  expMonth: number | null
  expYear: number | null
}

export interface SessionConfig {
  actions: string[]
  actionId: string
  sessionExpiresAt: string
  theme: Theme
  locale: string
}

export interface TokenizedCard {
  cardAlias: string
  cvvAlias: string
  brand: string | null
  last4: string
  expMonth: number
  expYear: number
}

export interface CardDraft extends TokenizedCard {
  nameOnCard: string
}

export interface TerminalError {
  code: ErrorCode
  message: string
}

export interface SuccessResult {
  action: typeof ACTION_SELECT | typeof ACTION_CARD_CREATE
  actionId: string
  paymentMethodId: number
  paymentType: PaymentMethodSummary['paymentType']
  brand: string | null
  last4: string
  expMonth: number | null
  expYear: number | null
  status: 'selected' | 'created'
}
